module.exports = __webpack_public_path__ + "static/media/ru.91ba7e40.svg";